var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-coupons"},[_c('ag-table',{attrs:{"data-source-api":_vm.getAllClientCoupon,"grid-options":_vm.gridOptions,"permissions":_vm.permissions,"rtl":false,"is-entities-response":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }